import { Heading } from '@simplywallst/ui-core/next';
import type { ReactNode } from 'react';

interface RiskRewardHeadingProps {
  children: ReactNode;
}
function RiskRewardHeading({ children }: RiskRewardHeadingProps) {
  if (!children) return null;
  return (
    <Heading
      as="h3"
      size="xSmall"
      weight="normal"
      className="!mt-x2 line-clamp-3 uppercase opacity-70 light:text-soft dark:text-soft"
    >
      {children}
    </Heading>
  );
}

export default RiskRewardHeading;
